/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PlanIndexPathParams, PlanIndexQueryParams, PlanIndexResponse } from '../types/PlanIndex'

/**
 * GET /:organisation/plans
 * @see backend/nexus/modules/Billing/Http/Controllers/PlanController.php PlanController::index
 */
export async function planIndex(
	organisation: PlanIndexPathParams['organisation'],
	params?: PlanIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PlanIndexResponse>> {
	return axiosInstance.get(`/${organisation}/plans`, { params, ...config })
}
